export default "__VITE_ASSET__Bz8QRaUn__"